




























































































































































import { Component, Vue } from 'vue-property-decorator';
import UserStore, { UserStoreInterface } from '@/resource/user/user.store';
import ProfileLoading from '@/components/profile/ProfileLoading.vue';
import BeatLoader from 'vue-spinner/src/BeatLoader.vue';
import { validateEmail, validateNotEmpty } from '@/utils/form-validation';
import { ErrorCode } from '@/utils/response';
import { MetaInfo } from 'vue-meta/types/vue-meta';
import { UserStatus } from '@/resource/user/user.model';
import { getUserIsSuspended, getUserStatus } from '@/utils/cookie';
import PremiumBenefitItem, {
  BenefitTextType,
  PremiumBenefit,
} from '@/main-components/premium/PremiumBenefit.vue';
import MainButton from '@/main-components/common/MainButton.vue';
import { manageSubscription } from '@/utils/subscription/subscription.util';
import seoDefault from '@/utils/seo-default';

interface ProfileForm {
  id: string;
  value: string;
  errorMessage: string | boolean;
}

interface ValidatePhoneNumber {
  number: { e164: string };
  isValid: boolean;
  country: string;
}

@Component({
  components: {
    ProfileLoading,
    BeatLoader,
    PremiumBenefitItem,
    MainButton,
  },
  metaInfo(this: Profile): MetaInfo {
    return {
      title: 'Profil Saya |',
      meta: [
        ...seoDefault({
          title: 'Profil Saya | Mysoalan',
          description:
            'Gunakan halaman Profil untuk mengedit maklumat akaun Mysoalan anda seperti nama, e-mel dan sekolah anda.',
        }),
      ],
    };
  },
})
export default class Profile extends Vue {
  userStore: UserStoreInterface = UserStore;
  isLoading = true;
  isSignOutLoading = false;

  loadingForms = [1, 2, 3, 4, 5];

  get userStatus(): UserStatus {
    return getUserStatus() || UserStatus.Free;
  }

  get isPremiumStatus() {
    return this.userStatus === UserStatus.Premium;
  }

  get userIsSuspended(): boolean {
    return getUserIsSuspended();
  }

  profileForms: ProfileForm[] = [];

  phoneNumberStatus: ValidatePhoneNumber | null = null;

  benefits: PremiumBenefit[] = [
    {
      isBenfit: true,
      texts: [
        {
          type: BenefitTextType.Highlight,
          text: 'Bank soalan',
        },
        {
          type: BenefitTextType.Normal,
          text: 'tanpa had',
        },
      ],
    },
    {
      isBenfit: true,
      texts: [
        {
          type: BenefitTextType.Normal,
          text: 'Koleksi',
        },
        {
          type: BenefitTextType.Highlight,
          text: 'latihan',
        },
        {
          type: BenefitTextType.Normal,
          text: 'tanpa had',
        },
      ],
    },
  ];

  async created() {
    await this.userStore.fetchUser();

    if (this.userStore.user) {
      for (const [key, value] of Object.entries(this.userStore.user)) {
        this.profileForms.push({
          id: key,
          value: value,
          errorMessage: false,
        });
      }
    }
    this.isLoading = false;
  }

  validatePhoneNumber(param: ValidatePhoneNumber) {
    this.phoneNumberStatus = param;
  }

  async updateProfileSubmitted() {
    if (this.isLoading) return;
    if (this.isSignOutLoading) return;
    this.isLoading = true;

    if (this.validateForms()) {
      this.isLoading = false;
      return;
    }

    const newUser: any = {};

    this.profileForms.forEach(profileForm => {
      newUser[profileForm.id] = profileForm.value;
    });

    await this.userStore.updateProfile(newUser);

    if (this.userStore.error)
      if (this.userStore.error.code === ErrorCode.EmailInUsedError) {
        this.profileForms = this.profileForms.map(profileForm => {
          if (profileForm.id === 'email') {
            profileForm.errorMessage = `Email already taken`;
          }
          return profileForm;
        });
      }

    this.isLoading = false;
  }

  validateForms(): boolean {
    let hasError = false;

    this.profileForms = this.profileForms.map(profileForm => {
      if (!validateNotEmpty(profileForm.value)) {
        profileForm.errorMessage = `${this.getTitle(
          profileForm.id,
        )} cannot empty`;

        hasError = true;
      } else {
        profileForm.errorMessage = false;
      }

      if (profileForm.id === 'email') {
        if (!validateEmail(profileForm.value)) {
          profileForm.errorMessage = `Not valid email`;

          hasError = true;
        } else {
          profileForm.errorMessage = false;
        }
      }

      if (profileForm.id === 'phoneNumber' && this.phoneNumberStatus) {
        if (!this.phoneNumberStatus.isValid) {
          profileForm.errorMessage = `Phone number is not valid`;

          hasError = true;
        } else {
          profileForm.errorMessage = false;
          profileForm.value = this.phoneNumberStatus.number.e164;
        }
      }

      return profileForm;
    });

    return hasError;
  }

  getTitle(title: string) {
    const separatedText = this.$lodash.startCase(title).toLowerCase();
    return this.$lodash.upperFirst(separatedText);
  }

  async signOutClicked() {
    if (this.isLoading) return;
    if (this.isSignOutLoading) return;
    this.isSignOutLoading = true;

    await this.userStore.signout();

    this.$router.push({
      name: 'home',
    });
  }

  async manageSubscriptionClick() {
    const billingPortalUrl = await manageSubscription();

    if (billingPortalUrl) {
      return window.location.assign(billingPortalUrl);
    } else {
      this.$toasted.global.mainToast({
        message: 'Something is wrong, please contact us at hello@mysoalan.com',
      });
    }
  }

  subscribeClicked() {
    this.$router.push('/pricing');
  }

  phoneNumberFixed =
    'bg-white-100 text-14 text-black-100 rounded py-14 px-14 w-full leading-normal';

  phoneNumberMain = `${this.phoneNumberFixed} bg-gray_light-primary rounded-DEFAULT border-1 border-solid border-gray_dark-primary`;
  phoneNumberError = `${this.phoneNumberFixed} bg-brand_light-secondary border-error-primary rounded-DEFAULT border-1 border-solid`;
}
